import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-store-2-line', title: 'Ekonomik ve Hızlı Teslimat', desc: 'E-ihracattaki uzman kadromuz ile e-ticaret gönderilerinizi tüm dünyadaki müşterilerinize ekonomik ve hızlı çözümler ile teslimatı gerçekleştiriyoruz.' },
  { icon: 'ri-money-dollar-circle-line', title: 'KDV İadesi', desc: 'Mikro ihracat ile hızlı gümrükleme ve KDV iadesi alınabilmesi sağlanır.' },
  { icon: 'ri-settings-3-line', title: 'API & CargoNet PANEL', desc: 'API, CargoNet PANEL gibi entegrasyonlar ile kolay ve anlık veri akışı sağlanır.' },
  { icon: 'ri-truck-line', title: 'Güvenli Dağıtım', desc: 'Sektörün tanınmış dağıtım firmaları ile güvenli dağıtım modelleri uygulanır.' },
  { icon: 'ri-global-line', title: 'Yurtdışı Depolama', desc: 'Yurtdışında depolama ve yeniden teslimata hazırlanması fırsatı sunulur.' },
  { icon: 'ri-lightbulb-line', title: 'Özel İş Modeli', desc: 'İş modelinize uygun özel tasarlanır, ürün modelleri geliştirilebilir.' },
];

const integrations = ['Amazon', 'eBay', 'Etsy', 'Shopify', 'WooCommerce', 'Trendyol Global'];

export default function ETicaretPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=global%20e-commerce%20concept%20with%20digital%20shopping%20cart%20hologram%20over%20world%20map%2C%20glowing%20network%20connections%20between%20continents%2C%20dark%20navy%20background%20with%20orange%20and%20teal%20accent%20lights%2C%20futuristic%20technology%20visualization%2C%20packages%20and%20delivery%20icons%20floating%2C%20cinematic%20digital%20art&width=1920&height=680&seq=eticaret-hero-01&orientation=landscape"
            alt="E-Ticaret"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(10,10,25,0.90) 0%, rgba(15,20,45,0.78) 55%, rgba(10,10,25,0.55) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-25">
          <div className="absolute top-20 right-24 w-96 h-96 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(130px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Uluslararası E-Ticaret Servisi</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-store-2-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Uluslararası E-Ticaret Servisi</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                E-İhracatta<br />
                <span style={{ color: 'var(--orange)' }}>Uzman Çözümler</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                E-ihracattaki uzman kadromuz ile e-ticaret gönderilerinizi tüm dünyadaki müşterilerinize ekonomik ve hızlı çözümler ile teslim ediyoruz. API entegrasyonu, KDV iadesi ve özel iş modelleri.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[
                { val: 'API', lbl: 'Entegrasyon' },
                { val: 'KDV', lbl: 'İadesi' },
                { val: 'Hızlı', lbl: 'Gümrükleme' },
                { val: '7/24', lbl: 'Destek' },
              ].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Integrations banner */}
      <section className="py-10" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <p className="text-xs font-semibold uppercase tracking-widest mb-6 text-center" style={{ color: 'var(--text3)' }}>Entegrasyon Desteği</p>
          <div className="flex flex-wrap justify-center gap-4">
            {integrations.map((name, i) => (
              <div key={i} className="px-5 py-2 rounded-full text-sm font-semibold" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text2)' }}>
                {name}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=person%20packing%20products%20for%20international%20shipping%2C%20e-commerce%20fulfillment%20center%2C%20boxes%20with%20shipping%20labels%2C%20organized%20workspace%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%2C%20clean%20background%20with%20orange%20accents&width=420&height=280&seq=eticaret-content-01&orientation=landscape"
                alt="E-ticaret operasyon"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Hizmet Kapsamı</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                E-ihracattaki uzman kadromuz ile e-ticaret gönderilerinizi tüm dünyadaki müşterilerinize ekonomik ve hızlı çözümler ile teslimatı gerçekleştiren servistir. Mikro ihracat ile hızlı gümrükleme ve KDV iadesi alınabilmesi sağlanır.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                API, CargoNet PANEL gibi entegrasyonlar ile kolay ve anlık veri akışı sağlanır. Sektörün tanınmış dağıtım firmaları ile güvenli dağıtım modelleri uygulanır.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>E-Ticaret Gönderileriniz İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz en uygun fiyat ve en hızlı çözümü sizin için hazırlasın.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
